export enum ServiceType {
  Compute = 'compute',
  Image = 'image',
  Storage = 'storage',
  Network = 'network',
  Metadata = 'metadata',
}

// KB article explaining why a network's metadata breaks (missing distributed port) and
// how to fix it. Linked from the Metadata Service card when networks are broken.
export const METADATA_TROUBLESHOOT_DOC_URL =
  'https://platform9.com/kb/pcd/networking/vms-unable-to-retrieve-metadata-from-cloud-init'

export enum ServiceState {
  Up = 'up',
  Down = 'down',
  NetworkError = 'network_error',
  CertificateError = 'certificate_error',
}

export enum ServiceStatus {
  Healthy = 'Healthy',
  Unhealthy = 'Unhealthy',
  Maintenance = 'Maintenance',
  NetworkError = 'Network Error',
  CertificateError = 'Trust Image Library Certificate',
  Loading = 'Loading',
  Unknown = 'Unknown',
  SchedulingDisabled = 'Scheduling Disabled',
}
